
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_muuiu_17",
  "full-width": "awsui_full-width_8cbea_muuiu_44",
  "refresh": "awsui_refresh_8cbea_muuiu_47",
  "disabled": "awsui_disabled_8cbea_muuiu_53",
  "selected": "awsui_selected_8cbea_muuiu_110",
  "icon": "awsui_icon_8cbea_muuiu_120",
  "with-text": "awsui_with-text_8cbea_muuiu_124",
  "with-no-text": "awsui_with-no-text_8cbea_muuiu_130",
  "root": "awsui_root_8cbea_muuiu_135",
  "segment-part": "awsui_segment-part_8cbea_muuiu_167",
  "grouped": "awsui_grouped_8cbea_muuiu_188",
  "grouped-only": "awsui_grouped-only_8cbea_muuiu_188",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_muuiu_192",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_muuiu_203",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_muuiu_207",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_muuiu_213",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_muuiu_217",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_muuiu_221",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_muuiu_227",
  "grouped-end-action-horizontal-last": "awsui_grouped-end-action-horizontal-last_8cbea_muuiu_231",
  "grouped-end-action-horizontal-only": "awsui_grouped-end-action-horizontal-only_8cbea_muuiu_231",
  "grouped-end-action-vertical-first": "awsui_grouped-end-action-vertical-first_8cbea_muuiu_235",
  "grouped-end-action-vertical-last": "awsui_grouped-end-action-vertical-last_8cbea_muuiu_235",
  "grouped-end-action-vertical-only": "awsui_grouped-end-action-vertical-only_8cbea_muuiu_235",
  "select": "awsui_select_8cbea_muuiu_110",
  "segment-count-2": "awsui_segment-count-2_8cbea_muuiu_252",
  "segment-count-3": "awsui_segment-count-3_8cbea_muuiu_259",
  "segment-count-4": "awsui_segment-count-4_8cbea_muuiu_266",
  "segment-count-5": "awsui_segment-count-5_8cbea_muuiu_273",
  "segment-count-6": "awsui_segment-count-6_8cbea_muuiu_280",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_muuiu_287"
};
  